import { defineComponent } from 'vue'
import { MetaInfo, MetaPropertyName, MetaPropertyProperty } from 'vue-meta'

export default defineComponent({
  name: 'MetaMixin',

  data() {
    return {
      metaTitle: 'DeepSource' as string,
      metaDescription: '' as string,
      metaImage: '' as string,
      metaImageAlt: '' as string,
      metaTwitterSiteAttribution: '@DeepSourceHQ' as string,
      setCanonical: false as boolean
    }
  },

  computed: {
    pageImageAltText(): string {
      return this.metaImageAlt || this.metaTitle
    },
    pageUrl(): string {
      const currentRoute = this.$route.path || ''
      const url = `https://${this.$config.domain}${currentRoute}`
      return url.slice(-1) === '/' ? url.slice(0, -1) : url
    },
    generateOpenGraphMeta(): MetaPropertyProperty[] {
      const meta: MetaPropertyProperty[] = [
        { hid: 'og:title', property: 'og:title', content: this.metaTitle },
        { hid: 'og:description', property: 'og:description', content: this.metaDescription },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl }
      ]

      if (this.metaImage) {
        meta.push(
          { hid: 'og:image', property: 'og:image', content: this.metaImage },
          { hid: 'og:image:secure_url', property: 'og:image:secure_url', content: this.metaImage },
          { hid: 'og:image:alt', property: 'og:image:alt', content: this.pageImageAltText }
        )
      }

      return meta
    },
    generateTwitterMeta(): (MetaPropertyName | MetaPropertyProperty)[] {
      const meta: (MetaPropertyName | MetaPropertyProperty)[] = [
        { hid: 'twitter:title', name: 'twitter:title', content: this.metaTitle },
        { hid: 'twitter:description', name: 'twitter:description', content: this.metaDescription },
        { hid: 'twitter:url', property: 'twitter:url', content: this.pageUrl },
        { hid: 'twitter:site', name: 'twitter:site', content: this.metaTwitterSiteAttribution }
      ]

      if (this.metaImage) {
        meta.push(
          { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
          { hid: 'twitter:image', property: 'twitter:image', content: this.metaImage },
          { hid: 'twitter:image:alt', name: 'twitter:image:alt', content: this.pageImageAltText }
        )
      }

      return meta
    },
    canonicalLinks(): Array<{ rel: string; href: string }> {
      return this.setCanonical ? [{ rel: 'canonical', href: this.pageUrl }] : []
    }
  },

  head(): MetaInfo {
    // This is a hack to make the variables reactive. Ref: https://vue-meta.nuxtjs.org/guide/caveats.html#reactive-variables-in-template-functions
    const metaTitle = this.metaTitle
    const metaDescription = this.metaDescription
    const openGraphMeta = this.generateOpenGraphMeta
    const twitterMeta = this.generateTwitterMeta
    const canonical = this.canonicalLinks

    return {
      title: metaTitle,
      meta: [
        { hid: 'description', name: 'description', content: metaDescription },
        ...openGraphMeta, // Correctly spread the array of objects into the meta field
        ...twitterMeta // Correctly spread the array of objects into the meta field
      ],
      link: [...canonical] // Spread the array for link tags as well
    }
  }
})
